<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Остатки на складах</h5>
      </div>
      <div class="card-body">
        <div class="flex justify-content-between">
          <div class="pr-2" style="flex:1">
            <DrugSearchNew
              :onSelect="getDrugData"
              ref="drugSearch"
            />
            <div class="alert alert-info p-2 mb-0 mt-1"
                 v-if="selectedDrug && (selectedDrug.pack_box_comment || selectedDrug.pack_comment)">
              {{ selectedDrug.pack_box_comment }}
              {{ selectedDrug.pack_comment }}
            </div>
          </div>
          <div>
            <button @click="getAllStoreData()" class="btn btn-info">Показать все препараты</button>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="loading || (selectedDrugs && selectedDrugs.length)">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
        <div v-if="!loading && (selectedDrug || storeData)">
          <table v-if="false" class="table table-sm table-hover">
            <thead>
            <tr>
              <th>Морион</th>
              <th>Наименование</th>
              <th>Склад</th>
              <th>Наличие</th>
              <th>Фактич</th>
              <th>Р. бронь</th>
              <th>Не р. бронь</th>
              <th>В дороге</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="drug in selectedDrugs" v-if="storeData.inStores[drug.id]">
              <tr class="main_tr">
                <td :rowspan="getRecordsCount(drug.id)">{{ drug.id }}</td>
                <td :rowspan="getRecordsCount(drug.id)">
                  <template v-if="allowToGetMoves">
                    <a :href="getExternalLink(drug)" target="_blank"><i class="icon-fa icon-fa-external-link"></i></a>
                    <span @click="mixinGoToRouter('NomenclatureStatistics', {drugId: drug.id})"
                          class="pointer">{{ drug.title }}</span>
                  </template>
                  <template v-else>
                    {{ drug.title }}
                  </template>
                  <p v-if="drug.pack_set && drug.pack_set != 1" class="mb-0 badge badge-info">комплект x
                    {{ drug.pack_set }}</p>
                </td>
              </tr>
              <template v-if="!drugInstoresExists(drug)">
                <tr>
                  <td colspan="10">Препарата нет ни на одном складе</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="store in $AllStores"
                    v-if="(storeData.inStores[drug.id] && storeData.inStores[drug.id][store.id]) || (storeData.requests[drug.id] && storeData.requests[drug.id][store.id]) || (storeData.transitDetails[drug.id] && storeData.transitDetails[drug.id][store.id])">
                  <td width="250px" v-bind:class="{grey_field: store.id === 3}">
                    <template v-if="allowToGetMoves">
                      <a :href="getExternalLink(drug, store.id)" target="_blank"><i
                        class="icon-fa icon-fa-external-link"></i></a>
                      <span class="pointer"
                            @click="mixinGoToRouter('NomenclatureStatistics', {drugId: drug.id, storeId: store.id })">{{
                          store.title
                        }} ({{ store.id }})</span>
                    </template>
                    <template v-else>
                      {{ store.title }}
                    </template>
                  </td>
                  <td class="grey_field w_store_d">
                    <strong>{{ (Math.round(storeData.inStores[drug.id][store.id] * 10) / 10) || 0 }}</strong></td>
                  <td class="w_store_d">
                    {{ storeData.actualStoreData[drug.id] && storeData.actualStoreData[drug.id][store.id] || 0 }}
                  </td>
                  <td class="w_store_d">
                    <template
                      v-if="storeData.requests && storeData.requests[drug.id] && storeData.requests[drug.id][store.id] && storeData.requests[drug.id][store.id][reserveTypes.appointedReserve] && storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].qty">
                      <template v-if="showStoreDataTooltip[drug.id]">
                        <v-popover
                          class=""
                          popoverClass="1111 p-3"
                          popoverInnerClass="upload_file_component_popover"
                          :update="(open) => {console.log('111', open);}"
                          :close-directive="() => {console.log('1112');}"
                          trigger="hover"
                          :auto-hide="true">
                          <div class="badge badge-dark pointer fs-12">
                            {{ storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].qty }}
                          </div>
                          <template slot="popover">
                            <div class="pre_image">
                              Заявки:
                              <p class="mb-1"
                                 v-for="o in storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].orders">
                                {{ o }}</p>
                              <p>
                                <a href="#"
                                   @click.prevent="openInNewPage('searchOrder', {ordersId: storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].orders})">
                                  Показать заявки
                                </a>
                              </p>
                            </div>
                          </template>
                        </v-popover>
                      </template>
                      <template v-else>
                        <div @mouseover="showStoreDataTooltip[drug.id] = true" class="badge badge-dark pointer fs-12">
                          {{ storeData.requests[drug.id][store.id][reserveTypes.appointedReserve].qty }}
                        </div>
                      </template>
                    </template>
                    <template v-else>0</template>
                  </td>
                  <td class="w_store_d">
                    <template
                      v-if="storeData.requests && storeData.requests[drug.id] && storeData.requests[drug.id][store.id] && storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve] && storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].qty">
                      <template v-if="showStoreDataTooltip[drug.id]">
                        <v-popover
                          class=""
                          popoverClass="1111 p-3"
                          popoverInnerClass="upload_file_component_popover"
                          :update="(open) => {console.log('111', open);}"
                          :close-directive="() => {console.log('1112');}"
                          trigger="hover"
                          :auto-hide="true">
                          <div class="badge badge-dark pointer fs-12">
                            {{ storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].qty }}
                          </div>
                          <template slot="popover">
                            <div class="pre_image">
                              Заявки:
                              <p class="mb-1"
                                 v-for="o in storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].orders">
                                {{ o }}</p>
                              <p>
                                <a href="#"
                                   @click.prevent="openInNewPage('searchOrder', {ordersId: storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].orders})">
                                  Показать заявки
                                </a>
                              </p>
                            </div>
                          </template>
                        </v-popover>
                      </template>
                      <template v-else>
                        <div @mouseover="showStoreDataTooltip[drug.id] = true" class="badge badge-dark pointer fs-12">
                          {{ storeData.requests[drug.id][store.id][reserveTypes.noAppointedReserve].qty }}
                        </div>
                      </template>
                    </template>
                    <template v-else>0</template>
                  </td>
                  <td class="w_store_d">
                    <template v-if="storeData.transitDetails[drug.id] && storeData.transitDetails[drug.id][store.id]">
                      <template v-if="showStoreDataTooltip[drug.id]">
                        <v-popover
                          class=""
                          popoverClass="1111 p-3"
                          popoverInnerClass="upload_file_component_popover"
                          trigger="hover"
                          :auto-hide="true">
                          <div class="badge badge-dark pointer fs-12">
                            {{ getTransitQty(storeData.transitDetails[drug.id][store.id]) }}
                          </div>
                          <template slot="popover">
                            <div class="pre_image">
                              Накладные:
                              <template v-if="storeData.transitDetails[drug.id][store.id].details_in">
                                <p>Поступление:</p>
                                <p class="mb-1" v-for="i in storeData.transitDetails[drug.id][store.id].details_in">
                                  {{ i.invoice_id }} ({{ i.qty }})</p>
                              </template>
                              <template v-if="storeData.transitDetails[drug.id][store.id].details_out">
                                <p>Отправка:</p>
                                <p class="mb-1" v-for="i in storeData.transitDetails[drug.id][store.id].details_out">
                                  {{ i.invoice_id }} ({{ i.qty }})</p>
                              </template>
                            </div>
                          </template>
                        </v-popover>
                      </template>
                      <template v-else>
                        <div @mouseover="showStoreDataTooltip[drug.id] = true" class="badge badge-dark pointer fs-12">
                          {{ getTransitQty(storeData.transitDetails[drug.id][store.id]) }}
                        </div>
                      </template>
                    </template>
                    <template v-else>0</template>
                  </td>
                </tr>
              </template>
            </template>
            </tbody>
          </table>
          <StoreTable
            v-if="storeData"
            :showDrugTitle="true"
            :allowToGetMoves="allowToGetMoves"
            :selectedDrugs="selectedDrugs"
            :storeData="storeData"
          />
        </div>
        <back-to-top bottom="50px" right="50px">
          <button type="button" class="btn btn-info btn-to-top"><i class="icon-fa icon-fa-chevron-up"></i></button>
        </back-to-top>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import BackToTop from 'vue-backtotop'
import DrugSearchNew from "@/components/drugs/DrugSearchNew";
import StoreTable from "@/views/stores/components/StoreTable.vue";

export default {
  title: 'Остатки на складах',
  components: {
    BackToTop,
    DrugSearchNew,
    StoreTable,
  },
  computed: {
    $AllStores() {
      const stores = this.$store.getters['platform/stores']
      return _.orderBy(stores, 'id')
    },
  },
  data() {
    return {
      allowToGetMoves: false,
      loadingColor: this.$constants.LOADING_COLOR,
      loading: false,
      showStoreLegend: false,
      selectedDrug: null,
      selectedDrugs: [],
      showStoreDataTooltip: {},
      storeData: null,
      transitData: {},
      reserveTypes: {
        'noAppointedReserve': 1,
        'appointedReserve': 2
      }
    }
  },
  created() {
    if (this.$can('nomenclature/statistics')) {
      this.allowToGetMoves = true
    }
  },
  methods: {
    drugInstoresExists(drug) {
      return this.$AllStores.reduce((acc, store) => {
        if (!acc && (this.storeData.inStores[drug.id] && this.storeData.inStores[drug.id][store.id]) || (this.storeData.requests[drug.id] && this.storeData.requests[drug.id][store.id]) || (this.storeData.transitDetails[drug.id] && this.storeData.transitDetails[drug.id][store.id])) {
          acc = true;
        }
        return acc;
      }, false);
    },
    getExternalLink(drug, storeId = 0) {
      let props = this.$router.resolve({
        name: 'NomenclatureStatistics',
        params: {drug: drug.id},
      })
      return `${props.href}?drugId=${drug.id}&storeId=${storeId}`
    },
    getRecordsCount(drugId) {
      let qty = 1
      this.$AllStores.forEach((s) => {
        if ((this.storeData.inStores[drugId] && this.storeData.inStores[drugId][s.id]) || (this.storeData.requests[drugId] && this.storeData.requests[drugId][s.id]) || (this.storeData.transitDetails[drugId] && this.storeData.transitDetails[drugId][s.id])) {
          ++qty
        }
      })
      return qty === 1 ? 2 : qty
    },
    getTransitQty(invoiceData) {
      return +(invoiceData.in || 0) - +(invoiceData.out || 0)
    },
    async getDrugData(drug) {
      // console.log(drug);
      if (this.loading || !drug) return;
      this.selectedDrug = drug;
      this.loading = true;
      let query = ''
      if (drug.id) {
        query += '?drugId=' + drug.id
      } else {
        query += '?title=' + drug.title
      }
      if (this.$can('stores/status/autoAdjust')) {
        query += '&inv=1';
      }
      this.showStoreDataTooltip = {}
      const {data} = await api.index('/store/drugData' + query)
      if (data.success) {
        if (data.drugs) {
          this.selectedDrugs = data.drugs
        } else {
          this.selectedDrugs = []
          this.selectedDrugs.push({...this.selectedDrug})
        }
        this.showStoreDataTooltip = Object.keys(data.storeData.actualStoreData).reduce((acc, d) => {
          acc[d] = false
          return acc
        }, {})
        // console.log(this.showStoreDataTooltip)
        this.storeData = {...data.storeData, extraInvoices: data.invoices};
      } else {
        toastr['warning'](data.message || 'Ошибка сервера')
      }
      this.loading = false
    },
    async getAllStoreData() {
      if (this.loading) return
      this.loading = true
      this.storeData = null
      this.showStoreDataTooltip = {}
      const {data} = await api.index('/store/drugData')
      if (data.success) {
        this.showStoreDataTooltip = data.drugs.reduce((acc, d) => {
          acc[d.id] = false
          return acc
        }, {})
        this.selectedDrugs = _.orderBy(data.drugs, 'title')
        this.storeData = data.storeData
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
table.table thead {
  position: sticky;
  top: 59px;
  background-color: white;
}

span.pointer:hover {
  font-weight: bold;
}

.main_tr {
  border: 2px solid #aaaaaa;
}

.table_store_details {
  margin-bottom: 5px;
}

.w_store_d {
  width: 80px;
}

.btn i {
  text-align: center;
}

.grey_field {
  background-color: #f4f4f4;
}

table.table th {
  white-space: normal;
}

p {
  margin-bottom: 2px;
}
</style>
